import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { Link, animateScroll as scroll } from 'react-scroll';

import AboutInfo from './AboutInfo/AboutInfo';

import cl from './About.module.css';

const About = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  const position = props.aboutData.coordinates?.split(', ') || [41.9226605, 12.5102558];

  return (
    <section className={cl.app_about}>
      <AboutInfo shopStory={props.aboutData.story} cartItems={props.cartItems} />
    </section>
  );
};

export default About;
